// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e567a819","239":"9b227398","455":"f6ed77e9"}[chunkId] + ".chunk.js";
};